import React from 'react';
import { motion } from 'framer-motion';
const audiences = ['Principiantes', 'Terapeutas', 'Coaches', 'Astrólogos', 'Tarotistas', 'Personas interesadas en el desarrollo personal', 'Facilitadores holísticos'];
export function Audience() {
  return <section className="py-20 relative z-10 bg-mystic-900/50" data-id="element-58">
      <div className="container mx-auto px-4" data-id="element-59">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-60">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-61">
            ¿Para quién está pensada?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-62"></div>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-63">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          y: 15
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-mystic-800 border border-mystic-700 px-6 py-3 rounded-full text-white/80 font-medium hover:border-gold/50 hover:text-white transition-colors cursor-default" data-id="element-64">
              {item}
            </motion.div>)}
        </div>
      </div>
    </section>;
}